import { IsBoolean, IsDefined, IsISO8601, IsOptional, Matches } from 'class-validator';
import { TransformBoolean } from '../../custom-validation';

export class BillingSubscriptionSearchDto {
  @IsOptional()
  @TransformBoolean()
  @IsBoolean()
  isActive?: boolean;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  currentDay: string;
}